import type { CircularProgressProps } from "@mui/material";
import { Box, CircularProgress } from "@mui/material";

const StaticCircularProgress = (props: CircularProgressProps) => {
  return (
    <Box sx={{ width: props.size, height: props.size, position: "relative" }}>
      <CircularProgress
        thickness={8}
        {...props}
        variant="determinate"
        value={100}
        sx={{ color: "divider", position: "absolute", left: 0 }}
      />
      <CircularProgress
        thickness={8}
        {...props}
        variant="determinate"
        color="primary"
        sx={{ position: "absolute", left: 0 }}
      />
    </Box>
  );
};

export default StaticCircularProgress;
